import { createTheme, ThemeOptions } from "@mui/material";

export const HEADER_HEIGHT_SX = 64;
export const HEADER_HEIGHT_PX = `${HEADER_HEIGHT_SX}px`;

export type CustomPaletteMode = "light" | "dark" | "DENV" | "CHIKV" | "WNV";

export const getTheme = (mode: CustomPaletteMode) => {
  const baseTheme: ThemeOptions = {
    ...themeOptions,
    palette: {
      ...themeOptions.palette,
      success: {
        main: "#8BC34A",
        light: "#e7f7eb",
        ...(mode === "DENV"
          ? { contrastText: "#d21e66" }
          : mode === "CHIKV"
            ? { contrastText: "#ee621e" }
            : mode === "WNV"
              ? { contrastText: "#1DB2D1" }
              : {}),
      },
    },
  };

  return createTheme(baseTheme);
};

export const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#003366", // Your primary brand color
      contrastText: "#fff", // Text color on primary backgrounds
      light: "#004d7a",
    },
    secondary: {
      main: "#50C878", // Your secondary brand color
      contrastText: "#2B2B2B",
    },
    error: {
      main: "#B00020", // Your error color
    },
    warning: {
      main: "#FFA500", // Your warning color
    },
    info: {
      main: "#007BFF", // Your info color
    },
    success: {
      main: "#8BC34A", // Your success color
      light: "#e7f7eb",
    },
    grey: {
      50: "#E5E9EF",
      100: "#4D4D4D",
      900: "#2B2B2B",
    },
    background: {
      default: "#F5F5F5", // Your default background color
    },
    action: {
      disabledBackground: "rgba(0, 0, 0, 0.10)",
    },
  },
  typography: {
    h1: {
      fontSize: "96px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
    h2: {
      fontSize: "60px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
    h3: {
      fontSize: "48px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
    h4: {
      fontSize: "34px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
    h5: {
      fontSize: "24px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
    h6: {
      fontSize: "20px",
      fontWeight: "bold",
      fontFamily: "Poppins",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
};
